module.exports = __webpack_public_path__ + "img/leftMove.ba33744.png";